import { render, staticRenderFns } from "./TheHeaderBasic.vue?vue&type=template&id=3dd29010&scoped=true"
import script from "./TheHeaderBasic.vue?vue&type=script&lang=ts"
export * from "./TheHeaderBasic.vue?vue&type=script&lang=ts"
import style0 from "./TheHeaderBasic.vue?vue&type=style&index=0&id=3dd29010&prod&scoped=true&lang=scss"
import style1 from "./TheHeaderBasic.vue?vue&type=style&index=1&id=3dd29010&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd29010",
  null
  
)

export default component.exports